import { LocaleId } from '../interfaces/locale'

export const mapCurrencyToLocale = (countryCode?: string): LocaleId => {
    switch (countryCode) {
        case 'NOK':
            return LocaleId.NB_NO
        case 'DKK':
            return LocaleId.DA_DK
        case 'GBP':
            return LocaleId.EN_GB
        case 'SEK':
            return LocaleId.SV_SE
        default:
            return LocaleId.EN_GB
    }
}
